import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Backups — Betreiber-Sicht, nur lesend. Backup-Ziele, Pläne
 * (gesamt/aktiv/Plattform/DB), Runs-Aggregat nach Status der letzten 30 Tage
 * sowie die letzten Läufe. M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  targets: 42,
  plans: { total: 190, enabled: 171, platform: 12, db: 58 },
  runs: 4821,
  byStatus: [
    { status: 'ok', n: 4610 },
    { status: 'error', n: 141 },
    { status: 'running', n: 70 },
  ],
  recent: [
    { id: 90211, plan_id: 'plan_7f3a', status: 'ok', snapshot_id: 'snap_a91c22', bytes: 5_368_709_120, started_at: '2026-08-16T02:14:00Z', finished_at: '2026-08-16T02:31:00Z' },
    { id: 90210, plan_id: 'plan_2be1', status: 'error', snapshot_id: null, bytes: 0, started_at: '2026-08-16T02:05:00Z', finished_at: '2026-08-16T02:06:00Z' },
    { id: 90209, plan_id: 'plan_c40d', status: 'ok', snapshot_id: 'snap_4471aa', bytes: 12_884_901_888, started_at: '2026-08-16T01:40:00Z', finished_at: '2026-08-16T02:11:00Z' },
    { id: 90208, plan_id: 'plan_9911', status: 'ok', snapshot_id: 'snap_0f19d2', bytes: 734_003_200, started_at: '2026-08-16T01:30:00Z', finished_at: '2026-08-16T01:33:00Z' },
  ],
};

export function useBackupStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-backups', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/backups');
    },
    refetchInterval: 60_000,
  });
}
